<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button v-if="Yetki" type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{Sayfa.ButtonAdi}}
      </el-button>
    </div>
    <div class="icerik">
      <div class="ekranbos" v-if="!Liste"></div>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Tanim.toLowerCase().includes(search.toLowerCase()))"
        class="">

        <el-table-column
          :label="this.$t('eYonetim.13')"
          prop="Tanim">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>

          </template>
          <template v-if="Yetki" slot-scope="scope">
            <el-button-group>
              <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2 tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      v-if="Yetki"
      :title="FormData.Baslik"
      :visible.sync="ModalOlayi"
      center
      width="30%">
      <a @click="ModalOlayi = false;" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-form-item :label="$t('eYonetim.13')" prop="Tanim">
          <el-input v-model="Form.Tanim"></el-input>
        </el-form-item>
        <input type="hidden" v-model="Form.id">
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()"
                   icon="el-icon-check">{{$t('eGenel.0')}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ModalOlayi: false,
        Yetki: false,
        Sayfa: {
          ButtonAdi: this.$t('eYonetim.10'),
          Adi: this.$t('mYonetim.8'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Menu: [
            {Adi: this.$t('mYonetim.7'), Link: '/yonetim/sirket'},
            {Adi: this.$t('mYonetim.9'), Link: '/yonetim/sirket/teklif'}
          ],
          MenuDisplay: true,
          Arama: this.$t('eGenel.9')
        },
        search: '',
        Liste: [],
        FormData: {
          Baslik: null,
          Sil: false
        },
        FormHata: {
          Tanim: [
            {required: true, message: this.$t('eYonetim.14'), trigger: 'blur'}
          ]
        },
        Form: {
          Tanim: null,
          id: null
        },
        hata: {
          Tanim: null
        }
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'yonetim/sirket/meskenturu'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      DuzenleBtn(Veri) {
        this.ModalOlayi = true;
        this.FormData.Baslik = this.$t('eYonetim.11');
        this.FormData.Sil = true;
        this.Form.Tanim = Veri.Tanim;
        this.Form.id = Veri.id;
      },
      YeniBtn() {

        this.ModalOlayi = true;
        this.FormData.Baslik = this.$t('eYonetim.10');
        this.FormData.Sil = false;
        this.Form.Tanim = null;
        this.Form.id = 0;
        $("#TanimInput").focus();

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            if (this.Form.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.Form,
                path: 'yonetim/sirket/meskenturu/' + this.Form.id
              })
                .then(response => {
                  if (response.Durum == "OK") {
                    this.ModalOlayi = false;
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();

                  } else {

                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;

                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.Form, path: 'yonetim/sirket/meskenturu'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.ModalOlayi = false;
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/sirket/meskenturu/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
    },
    mounted() {
      this.SayfaYukle();

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Yonetim/sirket/MeskenTuru.vue